import React, { PureComponent } from 'react';
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
} from 'reactstrap';
import { connect } from 'react-redux';
import {
  updateStaffMember,
  resetUpdatePopupNP,
} from '../../redux/actions/staffActions';
import config, { USER_TYPES } from '../../config/app.config';
import DesignationSelect from '../../shared/components/inputs/DesignationSelect/DesignationSelect';
import { ResponseMessage } from '../../shared/components/ResponseMessage';
import { FormInput } from './components/FormInput';
import { PermissionsSelect } from './components/PermissionsSelect';
import { isPrimaryAdmin, isSuperAdmin } from '../../utils/Utils';
import FacilitySelect from '../../shared/components/inputs/FacilitySelect/FacilitySelect';
import { InputLabel } from '../../shared/components/InputLabel';
import localStorage from '../../libs/storageHelper';
import validateStaffForm from './staffValidate';
import Error from '../../shared/components/form/Error';

class ViewStaff extends PureComponent {
  constructor() {
    super();
    this.modalTimeOutRef = null;
    this.loggedUser = localStorage.getFromStorage('loggedUser');

    this.state = {
      modal: false,
      selectedMember: {},
      inputs: {
        firstName: '',
        lastName: '',
        email: '',
        facility: '',
        designation: '',
        username: '',
        phone: '',
        extension: '',
        type: USER_TYPES.STAFF,
        password: '',
        internalNotes: '',
        privateCredentials: false,
      },
      error: false,
      errors: {
        firstName: null,
        lastName: null,
        email: null,
        facility: null,
        designation: null,
        username: null,
        phone: null,
        extension: null,
        password: null,
        privateCredentials: null,
        internalNotes: null,
      },
      successResponse: null,
      errorResponse: null,
      refreshState: true,
    };
  }

  get canManageStaff() {
    const user = this.loggedUser.user;
    return isPrimaryAdmin(user) || isSuperAdmin(user);
  }

  get showInternalNotes() {
    return this.canManageStaff;
  }

  onChangeFields = (e) => {
    const property = e.target.name;
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    let { inputs, refreshState } = this.state;
    refreshState = !refreshState;
    inputs[property] = value;
    this.setState({ inputs, refreshState });
  };

  onSubmit = () => {
    this.setState({
      error: null,
      errors: {},
    });
    const { inputs } = this.state;
    const isPrivate = inputs.privateCredentials;

    const staff = {
      ...inputs,
      firstName: (inputs.firstName || '').trim(),
      lastName: (inputs.lastName || '').trim(),
      username: isPrivate
        ? (inputs.email || '').trim()
        : (inputs.username || '').trim(),
      email: isPrivate ? (inputs.email || '').trim() : '',
    };

    if (isPrivate) {
      delete staff.password;
    } else if (!(inputs.password || '').trim()) {
      delete staff.password;
    }

    if (!this.showInternalNotes) {
      delete staff.internalNotes;
    } else {
      staff.internalNotes = String(inputs.internalNotes || '').trim();
    }

    const { errors, error } = validateStaffForm(staff, false);

    if (error) {
      return this.setState({
        errors,
        error,
        errorResponse: null,
        successResponse: null,
      });
    }

    staff.phone = staff.phone
      ? staff.phone.replace(/[^A-Z0-9]+/gi, '')
      : staff.phone;

    this.props.updateStaffMember(this.state.selectedId, staff);
  };

  onRemove = () => {
    const { selectedId, selectedMember, inputs } = this.state;
    const label =
      selectedMember.fullName ||
      inputs.username ||
      inputs.email ||
      'this staff profile';
    this.closeModal();
    if (this.props.onRemove) {
      this.props.onRemove(selectedId, label);
    }
  };

  onResendInvite = () => {
    const { selectedId, selectedMember, inputs } = this.state;
    const label =
      selectedMember.firstName ||
      selectedMember.fullName ||
      inputs.username ||
      inputs.email ||
      'this staff member';
    this.closeModal();
    if (this.props.onResendInvite) {
      this.props.onResendInvite(selectedId, label);
    }
  };

  closeModal = () => {
    if (this.modalTimeOutRef) {
      clearTimeout(this.modalTimeOutRef);
    }
    const inputs = {
      firstName: '',
      lastName: '',
      email: '',
      facility: '',
      designation: '',
      username: '',
      phone: '',
      extension: '',
      password: '',
      internalNotes: '',
      privateCredentials: false,
    };
    this.setState({ inputs });
    this.toggle(false);
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  toggle(isOpen = !this.state.modal) {
    const error = false;
    const errors = {
      firstName: null,
      lastName: null,
      email: null,
      facility: null,
      designation: null,
      username: null,
      phone: null,
      extension: null,
      password: null,
      privateCredentials: null,
      internalNotes: null,
    };
    this.setState({
      modal: isOpen,
      error,
      errors,
      successResponse: null,
      errorResponse: null,
    });
  }

  UNSAFE_componentWillReceiveProps(np) {
    const { selectedId, selectedMember, view } = np;

    if (np.staff.updateStaffResponse) {
      this.setState({
        successResponse: 'Staff Profile updated successfully.',
        selectedMember: this.state.input,
        errorResponse: null,
      });
      this.closeModalWithTimeOut();
    }
    if (np.staff.updateStaffErrorResponse) {
      if (np.staff.updateStaffErrorResponse.errorMessage) {
        this.setState({
          errorResponse: np.staff.updateStaffErrorResponse.errorMessage,
          successResponse: null,
        });
      }
    }
    if (view && !this.state.modal) {
      const inputs = {
        firstName: selectedMember.firstName || '',
        lastName: selectedMember.lastName || '',
        email: selectedMember.email || '',
        facility: selectedMember.facilityId,
        designation: selectedMember.designationId,
        username: selectedMember.username || '',
        phone: selectedMember.phone,
        type: selectedMember.type,
        extension: selectedMember.extension,
        password: '',
        internalNotes: selectedMember.internalNotes || '',
        privateCredentials: selectedMember.privateCredentials,
      };
      this.props.resetUpdatePopupNP();
      this.setState({
        selectedId,
        selectedMember,
        inputs,
        modal: true,
        successResponse: null,
        errorResponse: null,
      });
    }
  }

  handleSelectFacility = (facility) => {
    let { inputs, refreshState } = this.state;
    refreshState = !refreshState;
    inputs.facility = facility;
    this.setState({ inputs, refreshState });
  };

  closeModalWithTimeOut = () => {
    this.modalTimeOutRef = setTimeout(() => {
      this.closeModal();
    }, config.POPUP_TIMEOUT_TIME);
  };

  render() {
    const { inputs, errors, successResponse, errorResponse, selectedMember } =
      this.state;
    const { handleSubmit } = this.props;
    const isPrivate = inputs.privateCredentials;
    const invitePending = isPrivate && !selectedMember.joined;

    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.closeModal}
        size="lg"
        backdrop={successResponse ? true : 'static'}
        keyboard
        className="model-form staff-modal"
      >
        <ModalHeader className="header-form">
          {isPrivate ? 'Staff Profile' : 'Assigned Credential'}
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody>
              <ResponseMessage
                type={successResponse ? 'success' : 'danger'}
                message={successResponse || errorResponse}
              />
              <form
                className="form staff-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (handleSubmit) handleSubmit(e);
                }}
              >
                <div className="container-fluid">
                  {isPrivate && (
                    <p className="staff-invite-status">
                      <span className="staff-invite-status-label">
                        Invite Status:
                      </span>{' '}
                      <span className="staff-invite-status-value">
                        {selectedMember.joined ? 'Accepted' : 'Pending'}
                      </span>
                    </p>
                  )}
                  {!isPrivate && (
                    <p className="staff-name-helper">
                      If entering a name, both First and Last Name are required.
                    </p>
                  )}
                  <div className="row">
                    <FormInput
                      wrapperClassName="col-md-6"
                      label="First Name"
                      name="firstName"
                      value={inputs.firstName}
                      onChange={this.onChangeFields}
                      error={errors.firstName}
                      required={isPrivate}
                      optional={!isPrivate}
                    />
                    <FormInput
                      wrapperClassName="col-md-6"
                      label="Last Name"
                      name="lastName"
                      value={inputs.lastName}
                      onChange={this.onChangeFields}
                      error={errors.lastName}
                      required={isPrivate}
                      optional={!isPrivate}
                    />
                  </div>

                  <div className="row">
                    {isSuperAdmin(this.loggedUser.user) && (
                      <div className="col-md-6">
                        <div className="form__form-group">
                          <InputLabel required>Facility</InputLabel>
                          <div className="form__form-group-field">
                            <FacilitySelect
                              onChange={this.handleSelectFacility}
                              value={inputs.facility}
                              error={errors.facility}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-md-6">
                      <DesignationSelect
                        onChange={this.onChangeFields}
                        value={inputs.designation}
                        error={errors.designation}
                        required={isPrivate}
                        optional={!isPrivate}
                      />
                    </div>
                    <div className="col-md-6">
                      <PermissionsSelect
                        value={inputs.type}
                        onChange={this.onChangeFields}
                        isPrivate={isPrivate}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <FormInput
                      wrapperClassName="col-md-6"
                      label="Email"
                      name="email"
                      onChange={this.onChangeFields}
                      value={inputs.email}
                      error={errors.email}
                      autoComplete="off"
                      required={isPrivate}
                      disabled
                      labelNote={
                        isPrivate ? '' : 'not used for Assigned Credentials'
                      }
                    />
                    <FormInput
                      wrapperClassName="col-md-6"
                      label="Username"
                      name="username"
                      onChange={this.onChangeFields}
                      value={isPrivate ? inputs.email : inputs.username}
                      error={errors.username}
                      disabled
                      required={!isPrivate}
                      labelNote={isPrivate ? 'same as Email' : ''}
                    />
                  </div>

                  <div className="row">
                    <FormInput
                      wrapperClassName="col-md-6"
                      label="Password"
                      name="password"
                      type={isPrivate ? 'text' : 'password'}
                      onChange={this.onChangeFields}
                      value={
                        isPrivate
                          ? 'Set by invited Staff Member after accepting their invitation.'
                          : inputs.password || ''
                      }
                      error={errors.password}
                      disabled={isPrivate}
                      autoComplete="new-password"
                      inputClassName={
                        isPrivate ? 'staff-password-disabled' : ''
                      }
                      belowLabel={
                        isPrivate ? null : (
                          <>
                            <span className="staff-field-note">
                              To change the password, enter a new one.
                            </span>
                            <span className="staff-field-note">
                              Leave blank to keep the current password.
                            </span>
                          </>
                        )
                      }
                    />
                    {this.showInternalNotes && (
                      <div className="col-md-6">
                        <div className="form__form-group">
                          <InputLabel>
                            Internal Notes
                            <span className="staff-field-note">
                              (optional)
                            </span>
                          </InputLabel>
                          {!isPrivate ? (
                            <div
                              className="staff-label-spacer-password-help"
                              aria-hidden="true"
                            />
                          ) : null}
                          <div className="form__form-group-field">
                            <FormGroup>
                              <textarea
                                className="form-control"
                                name="internalNotes"
                                value={inputs.internalNotes}
                                onChange={this.onChangeFields}
                                rows={3}
                                maxLength={500}
                              />
                              {errors.internalNotes && (
                                <Error text={errors.internalNotes} />
                              )}
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row align-items-center staff-form-footer">
                    <div className="col-md-6 text-left staff-form-footer-left">
                      {this.canManageStaff && (
                        <>
                          <Button
                            outline
                            color="danger"
                            className="staff-remove-btn"
                            onClick={this.onRemove}
                          >
                            Remove Staff
                          </Button>
                          {invitePending && (
                            <Button
                              color="primary"
                              className="save-update staff-resend-invite-btn"
                              onClick={this.onResendInvite}
                            >
                              Resend Invite
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                    <div className="col-md-6 text-right">
                      <Button
                        className="clear"
                        color="secondary"
                        onClick={this.closeModal}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="save-update"
                        color="primary"
                        onClick={this.onSubmit}
                      >
                        Update
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  updateStaffMember,
  resetUpdatePopupNP,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewStaff);
